// JEDYNE miejsce z domeną publiczną w src.
// Kolejna zmiana domeny = edycja stałej SITE_ORIGIN poniżej (plus env w skryptach
// node: scripts/sitemap-utils.js SITE_URL i prod env SITE_URL do stemplowania dist/).
export const SITE_ORIGIN = 'https://fitaily.com';

/** SITE_ORIGIN + path (leading slash opcjonalny; pusty path => sam origin). */
export function siteUrl(path = ''): string {
  if (!path) return SITE_ORIGIN;
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
